<template>
  <div class="x-button-group" :style="{'text-align': realAlign}">
    <template v-for="(item) in realButtonList">
      <slot v-if="item.slot" :name="item.slot.name" :item="item"></slot>
      <x-button-group-item v-else-if="item.render" :item="item" :key="item.field"></x-button-group-item>
      <div v-else-if="item.separator" class="x-button-group-separator" :key="item.field"></div>
      <el-dropdown v-else-if="hasChildren(item)" @command="handleCommand" trigger="click" :key="item.field" @visible-change="handleVisibleChange">
        <el-button plain class="x-dropdown-button">{{item.name}}<i class="el-icon--right" :class="{'el-icon-caret-bottom': !dropdownVisible, 'el-icon-caret-top': dropdownVisible}"></i></el-button>
        <template v-slot:dropdown>
          <el-dropdown-menu>
            <template v-slot:default>
              <el-dropdown-item v-for="child in item.children" :key="child.name" :command="child">{{child.name}}</el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <el-button v-else :icon="item.icon" :type="getButtonType({item})" :class="item.class" :plain="item.plain || false" :key="item.field" :disabled="item.disabled" @click="item.click({item, $event})"
      ><i v-if="item.prefixIcon" :class="item.prefixIcon" class="el-icon--left"></i>{{item.name}}<i  v-if="item.suffixIcon" :class="item.suffixIcon"  class="el-icon--right"></i>
      </el-button>
    </template>
    <div class="x-button-group-right">
      <template v-for="(item, index) in realRightButtonList">
        <slot v-if="item.slot" :name="item.slot.name" :item="item"></slot>
        <div v-else-if="item.separator" class="x-button-group-separator" :key="item.field"></div>
        <el-button v-else :icon="item.icon" :type="getButtonType({item})" :class="item.class" :plain="item.plain || false" :key="item.field" :disabled="item.disabled" @click="item.click({item, $event})"
        ><i v-if="item.prefixIcon" :class="item.prefixIcon" class="el-icon--left"></i>{{item.name}}<i  v-if="item.suffixIcon" :class="item.suffixIcon"  class="el-icon--right"></i>
        </el-button>
      </template>
    </div>
  </div>
</template>

<script>
  import {getButtonSlotArray, getButtonType} from '../../util/componentUtil';
import {
  getShowList
} from '../../util/componentCoreUtil';
import {Dropdown, DropdownMenu, DropdownItem, Button} from 'element-ui';
import XButtonGroupItem from './x-button-group-item';
function initButton (list) {
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (item.separator) {
      if (!Object.prototype.hasOwnProperty.call(item, 'separator')) {
        item.name = 'sp' + i + Date.now() + Math.random() * 1000;
      }
    }
    // 有children的，name默认为更多
    if (Array.isArray(item.children)) {
      if (!item.name) {
        item.name = '更多';
      }
      initButton(item.children);
    }
    if (!item.field) {
      item.field = item.name;
    }
  }
}
export default {
  name: 'XButtonGroup',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [XButtonGroupItem.name]: XButtonGroupItem
  },
  props: {
    buttonConfig: {
      type: Object,
      default () {
        return {
          align: 'left',
          list: [
            /* {
              slot: { // 插槽
                name: '' // 插槽名称
              },
              separator: {}, // 分隔符
              children: [] // 子元素，用于更多下拉按钮
            } */
          ],
          rightList: [] // 右边的按钮
        };
      }
    }
  },
  data() {
    return {
      dropdownVisible: false
    };
  },
  computed: {
    realAlign() {
      if (this.buttonConfig.align) {
        return this.buttonConfig.align;
      }
      return 'left';
    },
    buttonSlotArray() {
      return getButtonSlotArray({list: this.realButtonList});
    },
    realButtonList() {
      const list = getShowList({list: this.buttonConfig.list, config: this.buttonConfig});
      // 如果相邻的两个元素都是separator,需要将其中一个删掉
      // 如果第一个元素是separator也要删掉
      // 如果是最后一个元素是separator也要删除
      for (let i = list.length - 1; i > 0; i--) {
        const item = list[i];
        const previousItem = list[i - 1];
        if (item.separator && previousItem.separator) {
          list.splice(i, 1);
        }
      }
      if (list.length > 0 && list[0].separator) {
        list.splice(0, 1);
      }
      if (list.length > 0 && list[list.length - 1].separator) {
        list.splice(list.length - 1, 1);
      }
      return list;
    },
    realRightButtonList() {
      if (!Array.isArray(this.buttonConfig.rightList)) {
        return [];
      }
      return getShowList({list: this.buttonConfig.rightList, config: this.buttonConfig});
    }
  },
  methods: {
    handleCommand(item) {
      item.click && item.click({item});
    },
    getButtonType,
    hasChildren(item) {
      return Array.isArray(item.children) && item.children.length > 0;
    },
    handleVisibleChange(flag) {
      this.dropdownVisible = flag;
    }
  },
  watch: {
    'buttonConfig.list': {
      handler(newList) {
        initButton(newList);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
.x-button-group {
  position: relative;
  text-align: left;
  font-size: 0;
  .x-button-group-separator {
    display: inline-block;
    vertical-align: top;
    background-image: linear-gradient(90deg, #BBC5D9 0%, #BBC5D9 100%);
    width: 2px;
    height: 14px;
    background-size: 2px 16px;
    background-repeat: no-repeat;
    margin: 7px 10px 0 0;
  }
  .el-button[type=button], .el-dropdown {
    margin: 0 10px 4px 0;
  }
  .x-dropdown-button {
    margin: 0;
  }
  /*修复使用Microsoft YaHei等字体时，增加图标导致按钮高度增加1px的问题，如果是Arial字体则不存在这个问题，因为Arial的实际渲染高度是14px，Microsoft YaHei是16px*/
  .el-icon--left, .el-icon--right {
    vertical-align: top;
  }
  .x-button-group-right {
    position: absolute;
    right: 0;
    top: 0;
    .el-button[type=button]:last-child {
      margin-right: 0;
    }
  }
}
</style>
